var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWheel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_39493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4407 22.4772L52.3879 19.7109L46.1676 22.1367L45.3212 25.6807L42.0684 40.6542L52.6311 45.3234L53.9419 43.6062C55.7504 39.8424 56.7646 35.6132 56.7646 31.1429C56.7646 28.1217 56.2989 25.2107 55.4407 22.4772Z",
    fill: "#E54D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5659 38.8379L40.8587 40.6548L31.3281 47.4666L35.5758 57.0828L38.6083 57.8452V57.8464C45.385 55.2893 50.838 50.0705 53.9799 43.5277L44.5659 38.8379Z",
    fill: "#E25297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.977 47.7414L32.9548 46.3032L20.8704 44.4409L15.0645 53.9057L17.7369 57.3212V57.3224C21.1365 58.8061 24.8824 59.6277 28.8174 59.6277C32.2607 59.6277 35.5587 58.9992 38.6071 57.8466V57.8454L34.977 47.7414Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4292 44.1978L14.7123 33.4912L2.99268 37.1705V42.3225C5.82131 49.0429 11.124 54.4355 17.7387 57.3214V57.3202L21.9858 47.4656L21.4292 44.1978Z",
    fill: "#77CCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70978 17.5659L2.52748 21.1443H2.52629C1.37616 24.2556 0.747314 27.6248 0.747314 31.1427C0.747314 35.1116 1.54756 38.8898 2.99202 42.3226H2.9932L12.7699 38.1678L14.0482 35.1884L14.8157 20.5331L5.70978 17.5659Z",
    fill: "#29C18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2514 5.49365H16.597C10.1407 8.66734 5.06377 14.2759 2.5271 21.145H2.52828L12.4279 24.9856L18.9008 21.6605L27.4609 13.8471L22.2514 5.49365Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4465 25.6814L44.9279 23.3418L38.5376 24.9857L38.1934 27.9783C38.5209 28.9726 38.697 30.0377 38.697 31.1436C38.697 32.6741 38.3589 34.123 37.7549 35.4196L37.8932 37.8073L42.0685 40.0618L44.5657 38.8379C45.6721 36.511 46.2927 33.9011 46.2927 31.1436C46.2928 29.2377 45.9949 27.4026 45.4465 25.6814Z",
    fill: "#F79781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7548 35.4194C36.6756 37.7379 34.7465 39.5683 32.3753 40.4966L31.4639 42.2364L33.3638 47.1732L34.9782 47.7412C39.1898 46.1315 42.626 42.9207 44.5658 38.8378L37.7548 35.4194Z",
    fill: "#E9ADCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3757 40.4966C31.2729 40.9296 30.0731 41.1671 28.8189 41.1671C27.4761 41.1671 26.1972 40.896 25.0305 40.4019L23.037 40.6211L20.6658 45.5263L21.9855 47.4665C24.0848 48.3733 26.3946 48.8746 28.8189 48.8746C30.9868 48.8746 33.0625 48.474 34.9786 47.7412L32.3757 40.4966Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7767 35.1893L18.217 34.0449L13.1269 35.8347L12.7683 38.1687C14.5449 42.3439 17.857 45.6867 21.9835 47.4667L25.0285 40.402C22.6869 39.4161 20.7991 37.539 19.7767 35.1893Z",
    fill: "#BBE6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2764 6.14112C38.2811 3.92218 33.6947 2.65918 28.8188 2.65918C24.4369 2.65918 20.2903 3.6775 16.5964 5.49343L21.1485 15.2088L25.6709 17.2668L39.9004 19.7112L44.0407 10.7959L42.2764 6.14112Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8342 20.2758C59.9749 20.6872 59.7503 21.1346 59.3413 21.2642L55.5115 22.4768L48.2573 24.7737C46.6355 19.6593 43.1154 15.4098 38.5361 12.8814L42.2218 6.14057L44.1721 2.57347C44.3778 2.19565 44.8506 2.06251 45.2182 2.27961C51.9985 6.26771 57.2432 12.6451 59.8342 20.2758Z",
    fill: "#F79A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.941 31.1425C18.941 29.9466 19.1467 28.8 19.5262 27.7373L19.4389 23.5591H15.2031L12.428 24.9846C11.7282 26.9025 11.3452 28.9775 11.3452 31.1425C11.3452 33.6385 11.8535 36.0134 12.7708 38.1675L19.7791 35.1882C19.2401 33.9515 18.941 32.583 18.941 31.1425Z",
    fill: "#94DAC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6924 16.3712L21.1464 15.2085C17.1357 17.1971 13.988 20.7007 12.4253 24.985L19.5235 27.7377C20.3887 25.3077 22.1524 23.3142 24.4089 22.1712V22.17L26.0349 20.3122L24.6924 16.3712Z",
    fill: "#C4DD81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1354 15.5442L37.1338 15.544C34.6611 14.1839 31.829 13.4116 28.8185 13.4116C26.0667 13.4116 23.4638 14.0569 21.1482 15.2084L24.4106 22.1711C25.7369 21.4994 27.2345 21.1192 28.8185 21.1192C30.4923 21.1192 32.0679 21.5414 33.4486 22.2874L35.9346 22.4115L38.3672 19.1205L37.1354 15.5442Z",
    fill: "#FFEDAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.258 24.7742L45.3927 25.6809L38.1926 27.9778C37.3876 25.5202 35.6292 23.464 33.407 22.2658L37.0817 15.5446L38.5368 12.8818C43.1161 15.4102 46.6362 19.6598 48.258 24.7742Z",
    fill: "#F8CD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1051 35.301C28.7796 35.301 28.5159 35.0334 28.5159 34.7031V27.0989C28.5159 26.7686 28.7796 26.501 29.1051 26.501C29.4306 26.501 29.6943 26.7686 29.6943 27.0989V34.7031C29.6943 35.0334 29.4306 35.301 29.1051 35.301Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8526 31.4995H25.3585C25.033 31.4995 24.7693 31.2319 24.7693 30.9016C24.7693 30.5713 25.033 30.3037 25.3585 30.3037H32.8526C33.1781 30.3037 33.4418 30.5713 33.4418 30.9016C33.4418 31.2319 33.1781 31.4995 32.8526 31.4995Z",
    fill: "#123051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_39493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.1304,
    height: 60,
    fill: "white",
    transform: "translate(0.747314 0.901367)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWheel);
export default __webpack_public_path__ + "static/media/AddWheel.f3e819d519f2f554af12705fcd9964fc.svg";
export { ForwardRef as ReactComponent };